const STORAGE_KEY = 'mmir.postAuthPath';
const ALLOWED_PATHS = new Set(['/lens']);
const MAX_AGE_MS = 5 * 60 * 1000;

export function rememberPostAuthPath(
  path,
  storage = window.sessionStorage,
  now = Date.now(),
) {
  if (!ALLOWED_PATHS.has(path)) return;
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify({ path, createdAt: now }));
  } catch (error) {
    // Storage can be unavailable in private browsing or by device policy.
  }
}

export function consumePostAuthPath(
  storage = window.sessionStorage,
  now = Date.now(),
) {
  try {
    const value = storage.getItem(STORAGE_KEY);
    storage.removeItem(STORAGE_KEY);
    if (!value) return null;
    const { path, createdAt } = JSON.parse(value);
    const age = now - createdAt;
    return ALLOWED_PATHS.has(path) && age >= 0 && age <= MAX_AGE_MS ? path : null;
  } catch (error) {
    return null;
  }
}

export function redirectToRememberedPath(
  storage = window.sessionStorage,
  location = window.location,
) {
  if (location.pathname !== '/') return false;
  const path = consumePostAuthPath(storage);
  if (!path) return false;
  location.assign(path);
  return true;
}
